import { generate_token_url, valida_dni_private_url, get_veeduria_padre_url } from "./urlBase"
import { apiCall } from "./apiCall";

const generateToken = async () => {
    try {

        // const resp = await fetch( generate_token_url, {
        //     method: 'POST',
        //     headers: { 'Content-Type': 'application/json',
        //                 'Access-Control-Allow-Origin': "*" },
        //     body: JSON.stringify({...padre})
        // })
        const resp = await fetch( generate_token_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': "*" },
            body: JSON.stringify(null)
        })
        const response = await resp.json()

        if ( response.Success ) {
            return response
        }
        else {
            console.log('padreHelper', '36')
            throw response
        }


        // const request = client(null)
        // const resp = await request.call( 'POST', valida_dni_url, padre )

        // const resp = await apiCall( 'POST', valida_dni_url, padre )
        // const response = resp.data

        // if ( response.Success ) {
        //     return response
        // }
        // else {
        //     console.log('padreHelper', '37')
        //     throw response
        // }

    } catch ( e ) {
        throw e
    }
}


const validaDNI = async ( padre ) => {

    try {
        const resp = await apiCall( 'POST', valida_dni_private_url, padre )
        const response = resp.data

        if ( response.Success ) {
            return response
        }
        else {
            console.log('padreHelper', '41')
            throw response
        }

    } catch ( e ) {
        console.log('padreHelper', e)
        console.log('padreHelper', '47')
        throw e
    }
}


const getVeeduriaPadre = async ( padre ) => {

    try {
        const resp = await apiCall( 'POST', get_veeduria_padre_url, padre )
        const response = resp.data
        
        if ( response.Success ) {
            return response
        }
        else {
            console.log('padreHelper', '41')
            throw response
        }

    } catch ( e ) {
        console.log('padreHelper', e)
        console.log('padreHelper', '47')
        throw e
    }
}


// const validaDNI = async ( padre ) => {

//     try {
//         const resp = await fetch( valida_dni_url, {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json',
//                         'Access-Control-Allow-Origin': "*" },
//             body: JSON.stringify({...padre})
//         })
//         const response = await resp.json()

//         if ( response.Success ) {
//             return response
//         }
//         else {
//             console.log('padreHelper', '36')
//             throw response
//         }



//     } catch ( e ) {
//         console.log('padreHelper', '47')
//         throw e
//     }
// }




export {
    generateToken,
    validaDNI,
    getVeeduriaPadre
}